module.exports = __webpack_public_path__ + "static/media/file_pick.d482704f.ico";